import { $enum } from 'ts-enum-util'
import { ITrailerStatesEnum } from 'types/graphqlTypes'
import { object, string, mixed } from 'yup'
import { TAG_STYLE } from 'transfix-ui'

export interface ITrailerStatusTag {
  value: string
  label: string
  style: TAG_STYLE
  outline?: boolean
}

interface ITrailerStatusTagMap {
  [variant: string]: ITrailerStatusTag
}

export const statusTagMap: ITrailerStatusTagMap = {
  inactive: {
    value: ITrailerStatesEnum.inactive,
    label: 'Inactive',
    style: TAG_STYLE.info,
    outline: true,
  },
  unassigned: {
    value: ITrailerStatesEnum.unassigned,
    label: 'Unassigned',
    style: TAG_STYLE.dark,
  },
  assigned_to_facility: {
    value: ITrailerStatesEnum.assigned_to_facility,
    label: 'Assigned Empty at Facility',
    style: TAG_STYLE.warning,
  },
  assigned_to_shipment: {
    value: ITrailerStatesEnum.assigned_to_shipment,
    label: 'Assigned to Load',
    style: TAG_STYLE.info,
  },
  empty_at_delivery: {
    value: ITrailerStatesEnum.empty_at_delivery,
    label: 'Empty at Delivery',
    style: TAG_STYLE.success,
  },
}

export const trailerStatusOptions = Object.keys(statusTagMap).map(key => ({
  value: key,
  label: statusTagMap[key].label,
  style: statusTagMap[key].style,
  outlineOnly: statusTagMap[key].outline,
}))

export const trailerStatusOptionsInactive = trailerStatusOptions.filter(
  item => item.value !== 'empty_at_delivery'
)

export const trailerStatusOptionsUnassigned = trailerStatusOptionsInactive

export const trailerStatusOptionsAssignedToFacility = trailerStatusOptionsInactive

export const trailerStatusOptionsAssignedInProgress = trailerStatusOptions.filter(
  item => item.value === 'assigned_to_shipment'
)

export const trailerStatusOptionsAssignedDelivered = trailerStatusOptions.filter(
  item =>
    item.value === 'assigned_to_shipment' ||
    item.value === 'empty_at_delivery' ||
    item.value === 'unassigned'
)

export const trailerStatusOptionsEmptyAtDelivery = trailerStatusOptions

export const TrailerStatusSchema = mixed<ITrailerStatesEnum>()
  .oneOf([...$enum(ITrailerStatesEnum).getValues()])
  .default(ITrailerStatesEnum.inactive)

const TagStyleSchema = mixed<TAG_STYLE>()
  .oneOf([...$enum(TAG_STYLE).getValues()])
  .default(TAG_STYLE.info)

export const TrailerStatusTagSchema = object({
  value: TrailerStatusSchema.required('Value is required').default(ITrailerStatesEnum.inactive),
  label: string().required('Label is required'),
  style: TagStyleSchema.required('Style is required').default(ITrailerStatesEnum.inactive),
})

export interface ITrailerSchema {
  carrier: string
  trailerNumber: string
  trailerLength?: string
  trailerType?: string
}

export const TrailerSchema = object<ITrailerSchema>({
  carrier: string().required('Carrier is required'),
  trailerNumber: string().required('Trailer Number is required'),
  trailerLength: string(),
  trailerType: string(),
})
